import AbstractProvidedClass from "../shared/AbstractProvidedClass";
import EventTypes from "../shared/EventTypes";

export default class AbstractSideBar extends AbstractProvidedClass {
    tabContainer;
    tabs;
    menuStart = 0;

    init() {
        this.width = 300;
        this.isOpen = true;
        this.x = this.p.width - (this.isOpen ? this.width : 0);
        this.y = 0;

        this.labelWidth = 36;
        this.labelHeight = 58;

        this.tabContainer = this.p.createDiv().parent('#p5canvas')
            .position(this.x - this.labelWidth, 0)
            .style('z-index', 2);

        this.closeButtonContainer = this.p.createDiv().parent(this.tabContainer)
            .size(this.labelWidth, this.menuStart + 50);
        this.closeButton = this.p.createButton('<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#arrow-right-line"></use></svg>')
            .parent(this.closeButtonContainer)
            .class('planner-tab -u-tt-bottom')
            .attribute('data-tooltip', 'Close sidebar')
            .size(this.labelWidth, 49)

            .mousePressed(() => this.emit(EventTypes.CLOSE_SIDEBAR));
        this.openButton = this.p.createButton('<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#arrow-left-line"></use></svg>')
            .parent(this.closeButtonContainer)
            .class('planner-tab -u-tt-bottom')
            .attribute('data-tooltip', 'Open sidebar')
            .size(this.labelWidth, 49)
            .mousePressed(() => this.emit(EventTypes.OPEN_SIDEBAR));

        this.openButton.hide();

        this.on(EventTypes.OPEN_SIDEBAR, () => {
            this.open();
            this.closeButton.show();
            this.openButton.hide();
        });
        this.on(EventTypes.CLOSE_SIDEBAR, () => {
            this.close();
            this.closeButton.hide();
            this.openButton.show();
        });
        this.on(EventTypes.RESIZE_WINDOW, () => this.resizeWindow());
    }

    resizeWindow() {
        this.x = this.x = this.p.width - (this.isOpen ? this.width : 0);
        this.tabContainer.position(this.x - this.labelWidth, 0);
        Object.values(this.tabs).map((tab) => tab.resizeWindow());
    }

    // The sidebar
    display() {
        this.p.noStroke();
        this.p.fill(255);
        this.p.stroke(100);
        this.p.strokeWeight(1);

        this.displayFirstTab();
        Object.keys(this.tabs).reverse().map((name, index) => this.displayTab(index));
        if (this.isOpen) {
            this.displayTab(Object.keys(this.tabs).findIndex((name) => name == this.openTab.name));
        }
    }

    hovered() {
        return this.p.mouseX > this.x
            || (this.p.mouseX > (this.x - this.labelWidth)
                && this.p.mouseY < this.tabContainer.elt.clientHeight);
    }

    setTab(tab) {
        this.openTab?.deactivate();
        this.openTab = this.tabs[tab];
        this.openTab.activate();
        this.emit(EventTypes.OPEN_SIDEBAR);
    }

    open() {
        this.isOpen = true;
        this.resizeWindow();
        this.openTab.activate();
    }

    close() {
        this.isOpen = false;
        this.resizeWindow();
        this.openTab.deactivate();
    }

    displayFirstTab() {
        this.p.fill('#B8E9E4');
        this.p.beginShape();
        this.p.vertex(this.x - this.labelWidth, 1);
        this.p.vertex(this.x - this.labelWidth, 30);
        this.p.bezierVertex(this.x - this.labelWidth, 50, this.x, 50, this.x, 70);
        this.p.vertex(this.x, this.p.height + 1);
        this.p.vertex(this.p.width + 1, this.p.height + 1);
        this.p.vertex(this.p.width + 1, -1);
        this.p.vertex(this.x - this.labelWidth, -1);
        this.p.endShape();
    }

    displayTab(index) {
        this.p.fill(255);
        let verticalOffset = this.menuStart + this.labelHeight * index;
        this.p.beginShape();
        this.p.vertex(this.x, -1);
        this.p.vertex(this.x, 30 + verticalOffset);
        this.p.bezierVertex(
            this.x,
            50 + verticalOffset,
            this.x - this.labelWidth,
            50 + verticalOffset,
            this.x - this.labelWidth,
            70 + verticalOffset
        )
        this.p.vertex(this.x - this.labelWidth, 90 + verticalOffset);
        this.p.bezierVertex(
            this.x - this.labelWidth,
            110 + verticalOffset,
            this.x,
            110 + verticalOffset,
            this.x,
            130 + verticalOffset
        );
        this.p.vertex(this.x, this.p.height + 1);
        this.p.vertex(this.p.width + 1, this.p.height + 1);
        this.p.vertex(this.p.width + 1, -1);
        this.p.vertex(this.x, -1);
        this.p.endShape();
    }
}
